__turbopack_context__.v({
  "button": "WhiteboardLessonCanvas-module__tx1JTG__button",
  "canvas": "WhiteboardLessonCanvas-module__tx1JTG__canvas",
  "content": "WhiteboardLessonCanvas-module__tx1JTG__content",
  "description": "WhiteboardLessonCanvas-module__tx1JTG__description",
  "eyebrow": "WhiteboardLessonCanvas-module__tx1JTG__eyebrow",
  "feedback": "WhiteboardLessonCanvas-module__tx1JTG__feedback",
  "group": "WhiteboardLessonCanvas-module__tx1JTG__group",
  "header": "WhiteboardLessonCanvas-module__tx1JTG__header",
  "headerTitle": "WhiteboardLessonCanvas-module__tx1JTG__headerTitle",
  "heading": "WhiteboardLessonCanvas-module__tx1JTG__heading",
  "input": "WhiteboardLessonCanvas-module__tx1JTG__input",
});
